import store from '@/study-search/store';

export default class ErrorPage {
	public goToRoot(): void {
		store.actions.resetApplicationFromErrorPageButton();
	}
}
